import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as API from "../../utils/api.service";
import { PUBLIC_URL } from "../../app.config";
import { Helmet } from "react-helmet";
import { useMenu } from "../../context/menuContext";
import {
  logoutRedirection,
  SWIT_LOGOUT,
  SWIT_SUCCESS,
} from "../../utils/common.service";
import { useDispatch } from "react-redux";
import { setLoader } from "../../Store/slices/MasterSlice";
import Cookies from "js-cookie";
import $ from "jquery";

const Navbar = ({ elementRef, visible, setVisible }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const path = "/" + location?.pathname?.split("/")?.[1];
  let adminData = JSON.parse(Cookies.get("dataCA"));
  const { menuState, toggleMenu } = useMenu();

  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggle = () => {
    if (elementRef.current) {
      // console.log("elementRef:", elementRef);
      $(elementRef.current).slideToggle();
      setVisible(!visible);
    }
  };

  const handleLogout = async () => {
    SWIT_LOGOUT(`You won't be able to delete this!`).then(async (result) => {
      if (result?.isConfirmed) {
        dispatch(setLoader(true));
        let { code, message } = await API.logoutApi();
        if (code === "1") {
          SWIT_SUCCESS(message);
          navigate("/login");
          logoutRedirection();
        }
        dispatch(setLoader(false));
      }
    });
  };
  useEffect(() => {
    const fullscreenChangeHandler = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", fullscreenChangeHandler);
    return () => {
      document.removeEventListener("fullscreenchange", fullscreenChangeHandler);
    };
  }, []);

  const handleFullscreen = () => {
    if (!isFullscreen) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <>
      <Helmet>
        <script src={`${PUBLIC_URL}/assets/js/app.min.js`}></script>
      </Helmet>

      <div
        className={`navbar-custom ${
          menuState === "hide" ? "custLeftsidebar" : ""
        }`}
      >
        <div className="topbar container-fluid">
          <div className="d-flex align-items-center gap-1">
            <div className="logo-topbar">
              {/* <!-- Logo light --> */}
              <Link to="/" className="logo-light">
                <span className="logo-lg">
                  <img
                    src={PUBLIC_URL + "/assets/images/logo.png"}
                    alt="logo"
                    style={{ height: "35px" }}
                  />
                </span>
                <span className="logo-sm">
                  <img
                    src={PUBLIC_URL + "/assets/images/logo-sm.png"}
                    alt="small logo"
                    style={{ height: "35px" }}
                  />
                </span>
              </Link>

              {/* <!-- Logo Dark --> */}
              <Link to="/" className="logo-dark">
                <span className="logo-lg">
                  <img
                    src={PUBLIC_URL + "/assets/images/logo-dark.png"}
                    alt="dark logo"
                    style={{ height: "35px" }}
                  />
                </span>
                <span className="logo-sm">
                  <img
                    src={PUBLIC_URL + "/assets/images/logo-sm.png"}
                    alt="small logo"
                    style={{ height: "35px" }}
                  />
                </span>
              </Link>
            </div>

            <button className="button-toggle-menu" onClick={toggleMenu}>
              <i className="ri-menu-line"></i>
            </button>

            <button
              className="navbar-toggle"
              data-bs-toggle="collapse"
              data-bs-target="#topnav-menu-content"
              onClick={toggle}
            >
              <div className="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>
          </div>

          <ul className="topbar-menu d-flex align-items-center gap-3">
            {/* <li className="d-none d-sm-inline-block">
                            <div className="nav-link" onClick={handleFullscreen}>
                                <i className={`${isFullscreen ? 'ri-fullscreen-exit-line' : 'ri-fullscreen-line'} fs-22`}></i>
                            </div>
                        </li> */}

            {/* <li className="d-none d-sm-inline-block">
                            <a className="nav-link" data-bs-toggle="offcanvas" href="#theme-settings-offcanvas">
                                <i className="ri-settings-3-line fs-22"></i>
                            </a>
                        </li> */}

            {/* <li className="d-none d-sm-inline-block">
                            <div className="nav-link" id="light-dark-mode">
                                <i className="ri-moon-line fs-22"></i>
                            </div>
                        </li> */}

            <li className="dropdown">
              <a
                className="nav-link dropdown-toggle arrow-none nav-user"
                data-bs-toggle="dropdown"
                role="button"
                aria-haspopup="false"
                aria-expanded="false"
              >
                <span className="account-user-avatar">
                  {/* <img src={PUBLIC_URL + "/assets/images/users/avatar-1.jpg"} alt="user-image" width="32" className="rounded-circle" /> */}
                  <img
                    src={adminData?.profile_image_link}
                    alt="user-image"
                    width="32"
                    height="32"
                    className="rounded-circle"
                  />
                </span>
                <span className="d-lg-block d-none">
                  <h5 className="my-0 fw-normal">
                    {adminData?.name}{" "}
                    <i className="ri-arrow-down-s-line d-none d-sm-inline-block align-middle"></i>
                  </h5>
                </span>
              </a>
              <div className="dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown">
                <div className=" dropdown-header noti-title">
                  <h6 className="text-overflow m-0">Welcome !</h6>
                </div>

                <Link
                  to="/my_account"
                  className={`dropdown-item ${
                    path === "/my_account" && "active menuitem-active"
                  }`}
                >
                  <i className="ri-account-circle-line fs-18 align-middle me-1"></i>
                  <span>My Account</span>
                </Link>

                {adminData?.role == "admin" && (
                  <Link
                    to="/setting"
                    className={`dropdown-item ${
                      path === "/setting" && "active menuitem-active"
                    }`}
                  >
                    <i className="ri-settings-4-line fs-18 align-middle me-1"></i>
                    <span>Settings</span>
                  </Link>
                )}

                {/* <a className="dropdown-item" onClick={() => handleLogout()}> */}
                <Link className="dropdown-item" onClick={() => handleLogout()}>
                  <i className="ri-logout-box-line fs-18 align-middle me-1"></i>
                  <span>Logout</span>
                </Link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
